module.exports = new __parcel__URL__("caligraphy.153dedf1.png").toString();